"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _toNumber = _interopRequireDefault(require("lodash/toNumber"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CurrencyUtil = /*#__PURE__*/function () {
  function CurrencyUtil() {
    _classCallCheck(this, CurrencyUtil);
  }

  _createClass(CurrencyUtil, null, [{
    key: "parseCurrency",
    value: function parseCurrency(stringOrNumber) {
      var withCurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var value = (0, _toNumber.default)(stringOrNumber);

      if ((0, _isNumber.default)(value) && !isNaN(value)) {
        if (withCurrency) {
          return new Intl.NumberFormat('ja-JP', {
            style: 'currency',
            currency: 'JPY'
          }).format(value);
        } else {
          return new Intl.NumberFormat('ja-JP').format(value);
        }
      }

      return undefined;
    }
  }]);

  return CurrencyUtil;
}();

exports.default = CurrencyUtil;